<template>
  <div class="root-box">
    <div class="query-container">
      <el-form size="small" :inline="true">
        <el-form-item label="公告类型：">
          <el-select v-model="param.type" placeholder="请选择" @change="query(1)" clearable>
            <el-option v-for="item in announcementTypeOpts" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="标题：">
          <el-input v-model="param.title" placeholder="请输入标题" clearable />
        </el-form-item>

        <el-form-item>
          <el-button style="width: 100px; margin-right: 20px" type="primary" @click="query(1)">查询</el-button>
        </el-form-item>

        <el-form-item style="float: right">
          <el-button style="width: 100px" type="primary" @click="openForm()">新增公告模板</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="table">
      <el-table :data="list" stripe max-height="600" @row-click="handleRowClick">
        <el-table-column label="序号" type="index" show-overflow-tooltip width="50"></el-table-column>

        <el-table-column prop="type" label="公告类型" width="120">
          <template slot-scope="scope">
            {{ scope.row.typeStr }}
          </template>
        </el-table-column>

        <el-table-column prop="toTheTop" label="置顶" width="120">
          <template slot-scope="scope">
            {{ scope.row.toTheTop | enumTransfer(yesNoOpts) }}
          </template>
        </el-table-column>

        <el-table-column prop="title" label="标题" min-width="200"></el-table-column>

        <el-table-column prop="content" label="内容" width="500">
          <template slot-scope="scope">
            <div style="max-height: 100px; overflow: hidden" v-html="scope.row.content"></div>
          </template>
        </el-table-column>

        <el-table-column prop="createTime" label="创建时间" width="180"></el-table-column>

        <el-table-column fixed="right" label="操作" width="280">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click.stop="previewAnnouncement(scope.row)">预览</el-button>
            <el-button type="text" size="small" @click.stop="openForm(scope.row)">修改</el-button>
            <el-button type="text" size="small" @click.stop="sendAnnouncement(scope.row)">发送</el-button>
            <el-button type="text" size="small" @click.stop="deleteTemplate(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="page">
      <el-pagination @current-change="handleCurrentChange" background :current-page="currentPage" :page-size="pageSize"
        layout="total, prev, pager, next, jumper" :total="total" :page-sizes="[10, 20, 50, 100]"></el-pagination>
    </div>

    <!-- 公告模板编辑弹窗 -->
    <el-dialog :visible.sync="formVisible" width="800px" max-height="600" title="公告模板" :close-on-click-modal="false">
      <el-form ref="form" :model="form" label-width="100px" :size="size" :rules="rules">
        <el-form-item label="公告类型：" prop="type">
          <el-select v-model="form.type" style="width: 100%" @change="handleTypeChange">
            <el-option v-for="item in announcementTypeOpts" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="标题：" prop="title">
          <el-input v-model="form.title" placeholder="请输入公告标题"></el-input>
        </el-form-item>

        <el-form-item label="置顶：" prop="toTheTop">
          <el-select v-model="form.toTheTop" placeholder="请选择">
            <el-option v-for="item in yesNoOpts" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="内容：" prop="content">
          <vue-tinymce v-model="form.content" :setup="setup" :setting="setting" :disabled="false" ref="editor" />
        </el-form-item>

        <el-form-item label="附件：">
          <multiple-file-upload v-model="form.annexes" :filePath="$ossPath.driverNotice()" :limit="10" />
        </el-form-item>
      </el-form>

      <span slot="footer">
        <el-button type="warning" :size="size" @click="saveOrUpdate">保存</el-button>
        <el-button type="info" :size="size" @click="formVisible = false">取 消</el-button>
      </span>
    </el-dialog>

    <!-- 公告预览弹窗 -->
    <el-dialog :visible.sync="previewVisible" width="600px" title="公告预览" @close="onPreviewClose"
      :close-on-click-modal="true">
      <div class="announcement-preview">
        <h3>{{ previewData.title }}</h3>
        <div class="announcement-type">
          类型：{{ previewData.type | enumTransfer(announcementTypeOpts) }}
        </div>
        <div class="announcement-content" v-html="previewData.content"></div>
        <div v-if="previewData.annexes && previewData.annexes.length" class="announcement-annexes">
          <h4>附件：</h4>
          <div class="annex-list">
            <div v-for="(annex, index) in previewData.annexes" :key="index" class="annex-item">
              <span class="annex-label">附件{{ index + 1 }}：</span>
              <file-preview :value="annex" />
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 发送公告弹窗 -->
    <el-dialog :visible.sync="sendVisible" width="1000px" title="发送公告" :close-on-click-modal="false">
      <div class="send-announcement">
        <div class="announcement-info">
          <h4>公告信息</h4>
          <p><strong>标题：</strong>{{ sendData.title }}</p>
          <p><strong>类型：</strong>{{ sendData.type | enumTransfer(announcementTypeOpts) }}</p>
          <p><strong>内容：</strong></p>
          <div v-html="sendData.content"></div>
        </div>

        <div class="driver-selector">
          <h4>选择接收司机</h4>
          <driver-selector ref="driverSelector" @input="handleDriverSelect" v-model="selectedDrivers" />
        </div>
      </div>

      <span slot="footer">
        <el-button type="primary" :size="size" @click="confirmSend" :disabled="!selectedDrivers.length">发送</el-button>
        <el-button type="info" :size="size" @click="sendVisible = false">取 消</el-button>
      </span>
    </el-dialog>

    <!-- 司机查看情况弹窗 -->
    <el-dialog :visible.sync="readStatsVisible" width="1000px" title="司机查看情况" :close-on-click-modal="true">
      <div class="read-stats-container">
        <div class="stats-summary">
          <el-row :gutter="20">
            <el-col :span="8">
              <div class="stat-item">
                <div class="stat-number">{{ driverReadStats.length || 0 }}</div>
                <div class="stat-label">总发送数</div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="stat-item">
                <div class="stat-number">{{ readCount }}</div>
                <div class="stat-label">已读数量</div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="stat-item">
                <div class="stat-number">{{ unreadCount }}</div>
                <div class="stat-label">未读数量</div>
              </div>
            </el-col>
          </el-row>
        </div>

        <div class="driver-list">
          <el-table :data="driverReadStats" stripe max-height="400">
            <el-table-column label="序号" type="index"></el-table-column>
            <el-table-column prop="driverNo" label="司机编号"></el-table-column>
            <el-table-column prop="driverName" label="司机姓名"></el-table-column>
            <el-table-column prop="isRead" label="阅读状态">
              <template slot-scope="scope">
                <el-tag :type="scope.row.isRead === true ? 'success' : 'info'">
                  {{ scope.row.isRead === true ? "已读" : "未读" }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="readTime" label="阅读时间">
              <template slot-scope="scope">
                {{ scope.row.readTime || "-" }}
              </template>
            </el-table-column>
            <el-table-column prop="sendTime" label="发送时间">
              <template slot-scope="scope">
                {{ scope.row.sendTime || "-" }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <span slot="footer">
        <el-button type="info" :size="size" @click="readStatsVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getAnnouncementTemplateList,
  createOrUpdateAnnouncementTemplate,
  deleteAnnouncementTemplate,
  sendDriverAnnouncement,
  getDriverAnnouncementReadStats
} from "@/api/announcement";
import { mapState } from "vuex";
import config from "@/config/config";
import { BaseDataService } from "@/service";

export default {
  components: {},
  created() {
    this.query();
  },
  computed: {
    ...mapState({
      size: (state) => state.btnSize
    }),
    announcementTypeOpts: () => [
      { label: "系统通告", value: "SYS" },
      { label: "安全问题通告", value: "SAFETY" },
      { label: "运营调整通告", value: "MANAGEMENT" },
      { label: "违规通报", value: "VIOLATION" },
      { label: "表扬宣传通告", value: "PRAISE_AND_PUBLICITY" },
      { label: "其他通告", value: "OTHERS" }
    ],
    uploadUrl() {
      return config.baseUrl + "/admin/upload/file";
    },
    // 计算已读数量
    readCount() {
      return this.driverReadStats.filter((item) => item.isRead === true).length;
    },
    // 计算未读数量
    unreadCount() {
      return this.driverReadStats.filter((item) => item.isRead === false).length;
    }
  },
  data() {
    return {
      yesNoOpts: BaseDataService.yesNoOpts(),
      formVisible: false,
      previewVisible: false,
      sendVisible: false,
      readStatsVisible: false,
      param: {},
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: config.pageSize,
      form: {},
      previewData: {},
      sendData: {},
      selectedDrivers: [],
      fileList: [],
      driverReadStats: [],
      rules: {
        type: [{ required: true, message: "请选择公告类型", trigger: "change" }],
        title: [{ required: true, message: "请输入公告标题", trigger: "blur" }],
        content: [{ required: true, message: "请输入公告内容", trigger: "blur" }]
      },
      setting: {
        height: 300,
        menubar: false,
        toolbar:
          "undo redo | fullscreen | formatselect alignleft aligncenter alignright alignjustify | link unlink | numlist bullist | fontsizeselect forecolor backcolor | bold italic underline strikethrough | indent outdent | removeformat |",
        toolbar_drawer: "sliding",
        quickbars_selection_toolbar:
          "removeformat | bold italic underline strikethrough | fontsizeselect forecolor backcolor",
        plugins: "lists fullscreen",
        language: "zh_CN",
        fontsize_formats: "12px 14px 16px 18px 24px 36px"
      }
    };
  },
  methods: {
    setup(editor) {
      this.editor = editor;
    },
    query(page = 1) {
      const param = {
        page: {
          current: page,
          size: this.pageSize
        },
        param: this.param
      };
      getAnnouncementTemplateList(param).then((res) => {
        const { records = [], current = 1, total = 0 } = res.data || {};
        this.list = records;
        this.currentPage = current;
        this.total = total;
      });
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.query(page);
    },
    openForm(item) {
      this.formVisible = true;

      if (item) {
        this.form = { ...item };
        if (item.annexes && item.annexes.length) {
          this.form.annexes = item.annexes.map((url, index) => ({
            name: `附件${index + 1}`,
            url: url
          }));
        }
        // 确保富文本编辑器内容正确设置
        this.$nextTick(() => {
          if (this.$refs.editor && this.$refs.editor.setContent) {
            this.$refs.editor.setContent(this.form.content || "");
          }
        });
      } else {
        this.form = {};
        // 清空富文本编辑器
        this.$nextTick(() => {
          if (this.$refs.editor && this.$refs.editor.setContent) {
            this.$refs.editor.setContent("");
          }
        });
      }
    },
    saveOrUpdate() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }

        const param = { ...this.form };
        param.annexes = (param.annexes || []).map((file) => file.url);

        // 从富文本编辑器获取内容
        if (this.$refs.editor && this.$refs.editor.getContent) {
          param.content = this.$refs.editor.getContent();
        }

        createOrUpdateAnnouncementTemplate(param).then(() => {
          this.$message.success(this.form.id ? "公告模板修改成功" : "公告模板新增成功");
          this.formVisible = false;
          this.query();
        });
      });
    },
    deleteTemplate(item) {
      this.$confirm("确定要删除这个公告模板吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        deleteAnnouncementTemplate(item.id).then(() => {
          this.$message.success("删除成功");
          this.query();
        });
      });
    },
    previewAnnouncement(item) {
      this.previewData = { ...item };
      this.previewVisible = true;
    },
    sendAnnouncement(item) {
      this.sendData = { ...item };
      this.selectedDrivers = [];
      this.sendVisible = true;
    },
    handleDriverSelect(driverIds) {
      this.selectedDrivers = driverIds;
    },
    confirmSend() {
      if (!this.selectedDrivers.length) {
        this.$message.warning("请选择接收司机");
        return;
      }

      const param = {
        id: this.sendData.id,
        sendDriverIds: this.selectedDrivers
      };

      sendDriverAnnouncement(param).then(() => {
        this.$message.success("公告发送成功");
        this.sendVisible = false;
      });
    },

    handleTypeChange(value) {
      if (value) {
        const typeStr = this.announcementTypeOpts.find((item) => item.value === value)?.label;
        this.$set(this.form, "typeStr", typeStr);
      }
    },
    onPreviewClose() {
      this.previewVisible = false;
      this.previewData = {};
    },
    // 处理行点击事件
    handleRowClick(row) {
      this.getDriverReadStats(row.id);
    },
    // 获取司机查看情况
    getDriverReadStats(templateId) {
      getDriverAnnouncementReadStats(templateId)
        .then((res) => {
          this.driverReadStats = res.data || [];
          this.readStatsVisible = true;
        })
        .catch(() => {
          this.$message.error("获取司机查看情况失败");
        });
    }
  }
};
</script>

<style scoped>
.announcement-preview {
  padding: 20px;
}

.announcement-preview h3 {
  color: #333;
  margin-bottom: 10px;
}

.announcement-type {
  color: #666;
  margin-bottom: 15px;
  font-size: 14px;
}

.announcement-content {
  line-height: 1.6;
  margin-bottom: 20px;
  word-wrap: break-word;
  word-break: break-all;
}

.announcement-content p {
  margin-bottom: 10px;
}

.announcement-content ul,
.announcement-content ol {
  margin-bottom: 10px;
  padding-left: 20px;
}

.announcement-content li {
  margin-bottom: 5px;
}

.announcement-content img {
  max-width: 100%;
  height: auto;
}

.announcement-annexes h4 {
  color: #333;
  margin-bottom: 10px;
}

.announcement-annexes .annex-list {
  margin-top: 10px;
}

.announcement-annexes .annex-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  padding: 8px;
  background-color: #f8f9fa;
  border-radius: 4px;
}

.announcement-annexes .annex-label {
  margin-right: 10px;
  font-weight: 500;
  color: #606266;
  min-width: 60px;
}

.send-announcement {
  padding: 20px;
}

.announcement-info {
  margin-bottom: 30px;
  padding: 15px;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.announcement-info h4 {
  margin-bottom: 15px;
  color: #333;
}

.announcement-info p {
  margin-bottom: 8px;
  line-height: 1.5;
}

.driver-selector h4 {
  margin-bottom: 15px;
  color: #333;
}

.read-stats-container {
  padding: 20px;
}

.stats-summary {
  margin-bottom: 30px;
  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 8px;
}

.stat-item {
  text-align: center;
  padding: 15px;
  background-color: white;
  border-radius: 6px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.stat-number {
  font-size: 28px;
  font-weight: bold;
  color: #409eff;
  margin-bottom: 8px;
}

.stat-label {
  font-size: 14px;
  color: #666;
}

.driver-list {
  margin-top: 20px;
}
</style>
